<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import ExportKeywordsButton from "@/components/competition/partials/keywords/ExportKeywordsButton.vue";
import SearchInput from "@/components/global-themed/SearchInput.vue";

const store = useStore();

const search = computed(() => store.getters['competitionV2/keywordSearch']);

const onSearchInput = (value) => {
  store.dispatch('competitionV2/setKeywordSearch', value);
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-center">
    <div class="tw-col-span-7">
      <SearchInput
        v-model="search"
        @update:model-value="onSearchInput"
      />
    </div>

    <div class="tw-col-span-5 tw-flex tw-justify-end">
      <ExportKeywordsButton />
    </div>
  </div>
</template>
